import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectMicroservicesAuthAIApiKey, selectMicroservicesUrl } from '@src/suite/common/store/global-tables/global-tables.selectors';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PlaybookOpenAiService {
    private store = inject(Store);
    private httpClient = inject(HttpClient);

    readonly microservicesAuthAIApiKey = this.store.selectSignal(selectMicroservicesAuthAIApiKey);
    readonly microservicesUrl = this.store.selectSignal(selectMicroservicesUrl);

    getPrompts() {
        const url = `${this.microservicesUrl()}/menu`;
        return this.httpClient
            .get<MicroserviceMenuResponse>(url, {
                headers: new HttpHeaders({
                    'x-api-key': this.microservicesAuthAIApiKey(),
                    'Content-Type': 'application/json',
                }),
            })
            .pipe(
                map(res => {
                    return res?.endpoints;
                })
            );
    }

    getCompletion(text: string, endpoint: string) {
        const url = `${this.microservicesUrl()}${endpoint}`;
        const requestParams = {
            story: text,
        };
        return this.httpClient.post(url, requestParams, {
            headers: new HttpHeaders({
                'x-api-key': this.microservicesAuthAIApiKey(),
                'Content-Type': 'application/json',
            }),
        });
    }
}
